
export interface IAddHospitalPrescriptionRefillRequest {
    hospitalPrescriptionId: number;
    hospitalPrescriptionRefillStatusId: number;
    hospitalId: number;
    hospitalPrescriptionRowVersion: string;
}

export class AddHospitalPrescriptionRefillRequest implements IAddHospitalPrescriptionRefillRequest {
    hospitalPrescriptionId: number;
    hospitalPrescriptionRefillStatusId: number;
    hospitalId: number;
    hospitalPrescriptionRowVersion: string;

    constructor(params: IAddHospitalPrescriptionRefillRequest) {
        this.hospitalPrescriptionId = params.hospitalPrescriptionId;
        this.hospitalPrescriptionRefillStatusId = params.hospitalPrescriptionRefillStatusId;
        this.hospitalId = params.hospitalId;
        this.hospitalPrescriptionRowVersion = params.hospitalPrescriptionRowVersion;
    }

    static ParseAddHospitalPrescriptionRefillRequest(hospitalPrescriptionId: number, hospitalPrescriptionRefillStatusId: number, hospitalId: number, hospitalPrescriptionRowVersion: string): IAddHospitalPrescriptionRefillRequest {
        return {
            hospitalPrescriptionId,
            hospitalPrescriptionRefillStatusId,
            hospitalId,
            hospitalPrescriptionRowVersion
        }
    }
}
